var styleDataHash = "83f0cdb9";
const injectCss = () => {
  var css = `.xY6sQ,.yG2jS{height:386px;overflow:auto}[dir] .xY6sQ,[dir] .yG2jS{margin-top:20px}[dir=ltr] .xY6sQ,[dir=ltr] .yG2jS{margin-right:-16px;padding-right:16px}[dir=rtl] .xY6sQ,[dir=rtl] .yG2jS{margin-left:-16px;padding-left:16px}.xY6sQ.ZbJ-O,.yG2jS.ZbJ-O{height:calc(100vh - 190px)}.wSMNc{display:flex;flex-direction:column}[dir=ltr] ._67kDP{float:right;text-align:right}[dir=rtl] ._67kDP{float:left;text-align:left}[dir] ._96QDQ{cursor:pointer}._96QDQ:focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}._0TT1p{align-items:center;display:flex;height:100%;justify-content:center;width:100%}[dir] ._0TT1p{margin-top:50px}.prjP4{height:100%;width:100%}.prjP4,.xY6sQ{align-items:center;display:flex;justify-content:center}.xY6sQ{max-width:100%}.tzBk3{--wds-input-value-font-size-medium:14px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var giphy_selector_default = {
  "giphy_selector_infinite_scroll_container": "yG2jS",
  "giphySelectorErrorContainer": "xY6sQ",
  "mobile": "ZbJ-O",
  "giphy_selector_infinite_scroll": "wSMNc",
  "giphy_selector_powerdByGiphy": "_67kDP",
  "giphy_selector_gif_img_container": "_96QDQ",
  "giphy_selector_spinner_load_more": "_0TT1p",
  "giphy_selector_spinner_empty_modal": "prjP4",
  "searchInput": "tzBk3"
};
export {
  giphy_selector_default as default,
  injectCss
};
//# sourceMappingURL=giphy-selector-scss.js.map
